import { render, staticRenderFns } from "./ProfessionSetting.vue?vue&type=template&id=c02079ae"
import script from "./ProfessionSetting.vue?vue&type=script&lang=js"
export * from "./ProfessionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports